/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Checkbox, Text, VFlow } from 'bold-ui'
import { gray } from 'bold-ui/lib/styles/colors'
import { Box } from 'components/Box'
import { GruposProcedimentosSdcDto, Procedimento, ProcedimentoSdcDto } from 'graphql/types.generated'

interface ExameSdcCheckboxProps {
  grupoExames: GruposProcedimentosSdcDto
  handleToggleProcedimento(procedimento: ProcedimentoSdcDto): void
  dataTestId?: string
}

export function ExameSdcCheckbox(props: Readonly<ExameSdcCheckboxProps>) {
  const { grupoExames, handleToggleProcedimento, dataTestId } = props
  const { titulo, procedimentosSdcDto } = grupoExames

  return (
    <Box>
      <VFlow>
        <Text fontWeight='bold'>{titulo}</Text>
        {procedimentosSdcDto.map((procedimento) => (
          <VFlow vSpacing={0} key={procedimento.exameSolicitado.codigo}>
            <span data-testid={dataTestId}>
              <Checkbox
                label={formatDescricao(procedimento.exameSolicitado)}
                onChange={() => handleToggleProcedimento(procedimento)}
              />
            </span>
            {procedimento.observacao && <Text style={styles.observacao}>{procedimento.observacao}</Text>}
          </VFlow>
        ))}
      </VFlow>
    </Box>
  )
}

const formatDescricao = (procedimento: Procedimento) => {
  const descricao = procedimento.procedimentoReferencia?.descricao || procedimento.descricao
  return descricao.charAt(0).toUpperCase() + descricao.slice(1).toLowerCase()
}

const styles = {
  observacao: css`
    color: ${gray.c30};
    padding-left: 2.25rem;
  `,
}
